import React, { useEffect, useState } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import IMAGES from "@/public/assets/img";
import { WEB_URL } from "@/config/endpoints";
import Image from "next/image";
import BusinessLoanPagesForm from "@/component/shared/businessLoansPages/hoverForm";
// import AccordianFaq from "@/component/shared/accordianfaq";
import KeyFeatures from "@/component/shared/businessLoansPages/keyFeatures";
import EligibilityCriteria from "@/component/shared/businessLoansPages/eligibilityCriteria";
import IdentityBusiness from "@/component/shared/businessLoansPages/identity";
import Slider from "@/component/shared/businessLoansPages/Slider";
// import FaqComponent from "@/component/shared/businessLoansPages/faqComponent";
import { ENDPOINTS } from "@/config/endpoints";
import { getServiceSchema } from "@/lib/serviceSchema";
import { customPagesContent } from "@/config/customPagesData";


import { pushCleverTapEvent } from "@/component/shared/pushCleverTapEvent";

const BusinessLoans = ({ businessLoanData}) => {
  const router = useRouter();
   const [mWidth, setMWidth] = useState(0);
   const firstPathSegment = router.asPath.split('/')[1];
  // const faqs =[
  //       {   id:0,
  //         Q:"What is Supply Chain Finance?",
  //         A:"Any private or public entity is eligible to avail supply chain finance. Sole proprietorship and partnership companies can also use this facility. Supply chain finance is like a high-tech helper for businesses that makes deals smoother, hassle-free, and more cost-effective. It's a set of smart processes using technology to bring down expenses and make things work better for everyone in a business deal. It’s like a tool that helps buyers and sellers in a transaction save money and do things faster."
  //       },
  //       {   id:1,
  //         Q:"What are the Documents Required for Supply Chain Finance?",
  //         A:"The documents required for supply chain finance is as follows:",
  //         list:["Identity proof","Address proof","Financial documents","Business ownership documents."]
  //       },
  //       {   id:2,
  //         Q:"What are the Types of trading services offered under Supply Chain Finance?",
  //         A:"The Types of trading services offered under Supply Chain Finance are as follows:",
  //         list:["Invoice Discounting","Dynamic Discounting","Supply Chain Financing Platforms","Receivables Finance","Payables Financing","Inventory Financing","Purchase Order Financing","Channel Financing"]
  //       },
  //       {   id:3,
  //         Q:"What is the Eligibility Criteria for Supply Chain Finance?",
  //         A:"To be able to avail of supply chain financing, the eligibility criteria is as follows:",
  //         list:["Creditworthiness","Indian Nationality","Business Vintage of at least 3 years","Transaction Volume","Trade Relationship","Invoices and Receivables","Supply Chain Visibility","Compliance","Financial Health","A good CIBIL score"]
  //       },
  //       {   id:4,
  //         Q:"What is the Interest Rates for Supply Chain Finance?",
  //         A:"There’s no one fixed rate of interest for supply chain finances. It depends on several factors like the provider, companies trustworthiness, creditworthiness, market conditions, and more. The interest rate is mostly competitive in nature."
  //       },
  //       {   id:5,
  //         Q:"How can one apply for Supply Chain Finance?",
  //         A:"",
  //         list:["Step 1: Login to our website https://www.credlix.com/","Step 2: Give all the necessary information required. ","Step 3: Go through the eligibility criteria thoroughly. ","Step 4: Agree on the financing terms with Credlix.","Step 5: The final approval."]
  //       },
  //       {   id:6,
  //         Q:"What are the Features & Benefits of Supply Chain Finance?",
  //         A:"Features and benefits of supply chain finance:",
  //         list:["Good working capital and cash flow ","Better inventory management. ","Good returns","Low cost","Digital, fast, and safe process","Up to 90% of invoices financed","No-collateral is required"]
  //       },
  //       {   id:7,
  //         Q:"Who all can avail Supply Chain Finance?",
  //         A:"Any private or public entity is eligible to avail supply chain finance. Sole proprietorship and partnership companies can also use this facility. "
  //       },
  //       {
  //         id:8,
  //         Q:"What is the repayment tenor of supply chain finance? ",
  //         A:"The repayment tenor of supply chain finance is 12 months. As per the business requirements, it can also be extended."
  //       },
  //       {
  //         id:9,
  //         Q:"What are the types of SME loans for supply chain finance? ",
  //         A:"The four common types of SME loans for supply chain finance are invoice financing, purchase order financing, supply chain financing, and inventory financing."
  //       },
  //       {
  //         id:10,
  //         Q:"How is the interest rate calculated and finalized by the company providing supply chain finance?",
  //         A:"The supply chain finance company calculates the interest rate based on how much of the credit limit the client has used up. "
  //       },
  //       {
  //         id:11,
  //         Q:"How many limits can a business avail from supply chain finance? ",
  //         A:"A business can receive up to 80% to 85% of the total value of the invoice. It also depends on the specific requirements and eligibility criteria set by the supply chain finance company. "
  //       }
  // ];
  const content = JSON.parse(businessLoanData);

  //   Service Schema
    const schemaData = getServiceSchema({
        metaTitle:content.seoData.title,
        pageUrl: WEB_URL+router.asPath,
        websiteLogo:IMAGES.SHARED.credlixLogo.src,
        mainImageUrl: content.bannerData.image.src,
        metaDescription:content.seoData.description,
        pageName: content.contentAfterBanner.heading
    });
    const handleWindowResize = () => {
    setMWidth(window.innerWidth);
  }
  //get banner
  const getDefaultBanner = () => {
    switch (firstPathSegment) {
      case 'export-factoring':
        return {
          desktop:IMAGES.businessLoansPages.exportFactoringBanner,
          mobile: IMAGES.businessLoansPages.exportFactoringBannerMb,
        };
      case 'business-loans':
        return {
          desktop: IMAGES.businessLoansPages.defaultBanner,
          mobile: IMAGES.businessLoansPages.defaultMbBanner
        };
      default:
        return {
          desktop: IMAGES.businessLoansPages.otherServBanner,
          mobile: IMAGES.businessLoansPages.otherServBannerMb
        };
    }
  };
  const { desktop, mobile } = getDefaultBanner();

     useEffect(() => {
        handleWindowResize();
        window.addEventListener('load', handleWindowResize);
        // unsubscribe from the event on component unmount
        return () => window.removeEventListener('resize', handleWindowResize);
    
      }, []);
useEffect(() => {
    pushCleverTapEvent("BL_Sector_Visited", {"PageName": 'Sector_Specific_Pages'});
  }, []);

  // console.log('content',content)

  return (
    <main className="pt-[110px]">
      <Head>  
        <title>{content.seoData.title}</title>
          <meta name="description" content={content.seoData.description} />
          {/* OpenGraph tags */} 
          <meta property="og:title" content={content.seoData.title}/>
          <meta property="og:description" content={content.seoData.description} />
          <meta property="og:image" content={IMAGES.HOMEIMG.bigLogoNew.src} />
          <meta property="og:url" content={WEB_URL+router.asPath} />
          <link rel="canonical" href={WEB_URL+router.asPath} />
          {firstPathSegment == 'export-factoring' && <>
            <link rel="preload" as="image"  href={IMAGES.businessLoansPages.exportFactoringBanner.src}/>
            <link rel="preload" as="image"  href={IMAGES.businessLoansPages.exportFactoringBannerMb.src}/>
          </>
          }
          {firstPathSegment == 'business-loans' && <>
            <link rel="preload" as="image"  href={content.bannerData.bannerImgDesktop || desktop.src}/>
            <link rel="preload" as="image"  href={content.bannerData.bannerImgDesktop || mobile.src}/>
          </>
          }
          {firstPathSegment !== 'export-factoring' && firstPathSegment !== 'business-loans' && 
            <><link rel="preload" as="image"  href={IMAGES.businessLoansPages.otherServBanner.src}/>
            <link rel="preload" as="image"  href={IMAGES.businessLoansPages.otherServBannerMb.src}/></>
          }
          <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
          />
    </Head>
      <section className={`relative bg-no-repeat sm:bg-center bg-cover bg-bottom ${content.bannerData.bannerImgDesktop ? '' : 'min-h-[450px] sm:min-h-[270px]'}`} >
        {mWidth > 768 ? 
        <Image
          priority={true}
          src={content.bannerData.bannerImgDesktop || desktop}
          width={1440}
          height={451}
          className="absolute inset-0 max-w-none w-full h-full"
        /> :
        <Image
          priority={true}
          src={content.bannerData.bannerImgDesktop || mobile}
          width={767}
          height={451}
          className="absolute inset-0 max-w-none w-full h-full"
        />
      }
        <div className='container lg:px-3 z-[1] relative px-3 xm:px-2'>
            <div className={`${content.bannerData.image ? '' : 'text-center'} flex flex-wrap`}>
                <div className={`${content.bannerData.image ? 'w-1/2 pt-[100px] pb-[80px]  sm:pt-[50px] sm:pb-[40px]' : 'w-full pt-[90px] pb-[100px] sm:pt-[50px] sm:pb-[60px]'} sm:w-full`}>
                    <span className="bg-[#FFB900] text-xl sm:text-base font-medium w-auto inline-block py-[8px]  px-5 rounded-md text-[#1A1A1A]">
                        {content.bannerData.title}
                    </span>
                    {/* <p className="text-[45px] mt-2 text-[#3C3C3C] leading-[70px] font-normal sm:text-xl">looking for quick, hassle-free 
                       
                    </p> */}
                    {/* {firstPathSegment == 'export-factoring' &&
                      <><p className={`mt-3 text-headingbig sm:text-xxl font-semibold ${content.bannerData.bannerImgDesktop ? 'text-[#3C3C3C] ':'text-white'}`}>EXPORT FACTORING?</p></>
                    } */}
                    {/* {firstPathSegment === 'business-loans' && (
                      <>
                      <p className="text-[38px] mt-2 text-[#3C3C3C] leading-[60px] font-normal sm:text-xl">looking for quick, hassle-free </p>
                      <span className="text-headingbig sm:text-xxl font-semibold text-[#3C3C3C]">
                        BUSINESS LOANS
                      </span></>
                    )} */}
                     {/* Default case */}
                      {firstPathSegment !== 'export-factoring' && firstPathSegment !== 'business-loans' && content.bannerData.textData && (
                        <>
                        <p className={`mt-3 text-headingbig sm:text-xxl font-semibold ${content.bannerData.bannerImgDesktop ? 'text-[#3C3C3C] ':'text-white'}`}>
                          {firstPathSegment.replace(/-/g, ' ').toUpperCase()}
                        </p></>
                      )}
                   
                    <p className={content.bannerData.image ? 'text-xl sm:text-lg mt-2 text-secondary' : 'mx-auto w-3/5 pt-6 text-3xl sm:text-lg text-secondary'}>{content.bannerData.textData}</p>
                </div>
                {content.bannerData.image && 
                <div className="w-1/2 sm:w-full pt-5 sm:pt-0 flex justify-center">
                <Image priority={true} fetchPriority="high" className='w-[450px] h-auto' src={content.bannerData.image} alt={content.bannerData.title} width={450} height={450} />
                </div>}
            </div>
        </div>
      </section>
      <section className="relative min-h-[160px] sm:pb-10 z-[1]">
        <div className='container lg:px-3 px-3 xm:px-2'>
             <BusinessLoanPagesForm />
        </div>
      </section>
      {content.contentAfterBanner &&
      <section className="relative pb-20 sm:pb-10">
          <div className='container lg:px-3 px-3 xm:px-2'>
            <div className=" w-full mx-auto max-w-[1100px]">
              <h1 className="text-xxl text-center mb-10 font-bold">{content.contentAfterBanner.heading}</h1>
              {content.contentAfterBanner.para &&
               <div className="bl-pages" dangerouslySetInnerHTML={{__html:content.contentAfterBanner.para}} />
                
              }  
            </div>
          </div>
      </section>
      }
      {/* <static content starts /> */}
      {firstPathSegment == 'export-factoring' &&
        <><KeyFeatures features={customPagesContent.KeyFeaturesExportFact} />
        <EligibilityCriteria eligibilityCriteria={customPagesContent.eligibilityPointsExport} />
        <IdentityBusiness identityDocuments={customPagesContent.identityDocumentsExport} /></>
        }
        {firstPathSegment == 'business-loans' &&
        <><KeyFeatures features={customPagesContent.KeyFeaturesLoan} />
        <EligibilityCriteria eligibilityCriteria={customPagesContent.eligibilityPoints} />
        <IdentityBusiness identityDocuments={customPagesContent.identityDocuments} /></>
        }
        {/* Default case */}
        {firstPathSegment !== 'export-factoring' && firstPathSegment !== 'business-loans' && (
          <><KeyFeatures features={customPagesContent.KeyFeaturesOtherPages} />
          <EligibilityCriteria eligibilityCriteria={customPagesContent.eligibilityPointsOthers} />
          <IdentityBusiness identityDocuments={customPagesContent.identityDocumentsOther} /></>
        )}
       
      
      {/* <static content ends /> */}
      {content.whatIsBL && 
      <section className="relative pb-20 sm:pb-10">
          <div className='container lg:px-3 px-3 xm:px-2'>
          <div className="w-full mx-auto max-w-[1100px]">
            <div className="bl-pages" dangerouslySetInnerHTML={{__html:content.whatIsBL}} />
            </div>
          </div>
      </section>
      }
      {content.benefits.heading && 
      <section className="relative pb-20 sm:pb-10">
          <div className='container lg:px-3 px-3 xm:px-2'>
          <h2 className="text-xxl text-center mb-5 font-bold">{content.benefits.heading}</h2>
          {content.benefits.para && 
          <p className="text-base text-center mb-7"> {content.benefits.para}</p>
          }
          <div className="w-full mx-auto max-w-[1100px]">
          {content.benefits.list.length > 1 &&
            <div className="flex flex-wrap">
               { content.benefits.list.map((item,i)=>(
                  <div className="text-base relative items-start last:mb-0 flex sm:flex-wrap sm:w-full w-[50%] sm:pr-0 pr-5 px-2 pl-[70px] mb-10" key={i}>
                    <span className="w-[50px] absolute text-xl leading-[50px] text-center rounded-[50%] h-[50px] left-0 bg-[#FECC2F] block sm:mb-2 mr-4">{i+1}</span>
                    <div className="pr-10 sm:pr-0 max-w-[90%] sm:max-w-full">
                      <h2 className="text-base font-medium mb-1">{item.title}</h2>
                      <p className="text-sm"> {item.content}</p>
                     </div>
                  </div>
                ))
               
              }
               </div>
            }
            </div>
          </div>
      </section>
      }
      {content.features.heading && 
      <section className="relative bg-[#FFFAED] py-20 sm:pb-10">
          <div className='container lg:px-3 px-3 xm:px-2'>
          <div className="w-full mx-auto max-w-[1100px]">
          <h2 className="text-xxl text-center mb-3 font-bold">{content.features.heading}</h2>
          <p className="text-base text-center mb-7"> {content.features.para}</p>
          {content.features.list.length > 1 &&
            <div className="flex flex-wrap justify-center">
               { content.features.list.map((item,i)=>(
                  <div className="text-base border-b-[5px] border-[#E3A003] items-start py-2 mx-1 sm:mx-0 sm:last:mb-0 rounded-md  bg-white shadow-md sm:w-full w-[23%] pr-5 px-2 mb-4" key={i}>
                      <h2 className="text-base text-center font-medium mb-1">{item.title}</h2>
                     <p className="text-sm text-center"> {item.content}</p>
                  </div>
                ))
               
              }
               </div>
            }
            </div>
          </div>
      </section>
      }
       {content.otherContent && 
      <section className="relative py-20 sm:pb-10">
          <div className='container lg:px-3 px-3 xm:px-2'>
            <div className="w-full mx-auto max-w-[1100px]">
            <div className="bl-pages" dangerouslySetInnerHTML={{__html:content.otherContent}} />
            </div>
          </div>
      </section>
      }
       {/* Customer Feedback and Recommendations Section Starts */}
       <section className="bg-[#F0F7FF] py-[80px] sm:pb-10">
          <div className="mx-auto w-full container">
            <div className="max-w-[1100px] mx-auto w-full">
              <div className="flex items-center justify-between sm:flex-col w-full">
              <div className="w-[30%] sm:w-full">
                <h2 className="text-xxl text-[#1A1A1A] font-bold mb-5 sm:mb-3">Customer Feedback and Recommendations</h2>
                <p className="text-base2 text-[#1A1A1A]"> Real stories from real clients showcasing their journey with us</p>
              </div>
              <div className="w-[65%] sm:w-full sm:mt-3">
                <Slider slides={customPagesContent.slidesData}/>
              </div>
              </div>
            </div>
          </div>
        </section>
        {/* Customer Feedback and Recommendations Section Ends */}

        {/* FAQ Section Ends */}
        {/* <section className='bg-white py-[80px] sm:pb-10 grid place-items-center'>
          <div className='container px-3 xm:px-2'>
            <div className="max-w-[1100px] mx-auto w-full">
                <h2 className='mb-6 font-bold text-center text-xxl text-secondary'>Frequently Asked Questions</h2>
              <FaqComponent faqs={faqs} />
            </div>
          </div>
        </section>  */}
        {/* FAQ Section Ends */}
        
        {/* <PopularSearch /> */}
     
    </main>
  );
};

export default BusinessLoans;

export async function getServerSideProps (context){
  const {res} = context;
  const customURl = context.params.custompage.replace(/^\/+/, '');
  const innerURL = context.params.innerPage;
  let businessData = null;
 try {
     const response = await fetch(ENDPOINTS.BUSINESS_LOAN_API+`?url=${customURl}/${innerURL}`)
     const data = await response.json();
     businessData = data;
   } catch (error) {
    console.error('Error:', error);
    res.statusCode = 500;
    return {
      notFound: true,
    };
   }
   if (!businessData?.data?.data) {
    res.statusCode = 404;
    return {
      notFound: true,
    };
  }
  return{
    props:{
      businessLoanData: businessData?.data.data,
    }
  }
}
